import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { Organizer } from '../../domain/interfaces/organizer';
import { UpsertOrganizerInput } from '../../domain/interfaces/upsert-organizer-input';
import i18n from 'i18n';
import organizerRepository from '../../domain/repositories/organizer-repository';
import organizerResource from '../../domain/resources/organizer-resource';
import { toast } from 'react-toastify';
import { addTournaments } from 'modules/tournaments/store/available-tournaments';

const PREFIX = 'organizer';

export const fetchOrganizer = createAsyncThunk<Organizer | null, { tournamentId: number }>(
  `${PREFIX}/fetchOrganizer`,
  async (payload, { rejectWithValue }) => {
    try {
      const organizer = await organizerRepository.fetchOrganizer(payload.tournamentId);
      if (!organizer) return null;

      return organizer;
    } catch (error) {
      console.error(`${PREFIX}/fetchOrganizers error:`, error);
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  },
);

export const upsertOrganizer = createAsyncThunk<Organizer, UpsertOrganizerInput>(
  `${PREFIX}/upsertOrganizer`,
  async (payload, { dispatch }) => {
    const { id, name, description, phone, email, address, sportType, adminUserId, logo } = payload;

    try {
      let organizer = await organizerRepository.upsertOrganizer({
        id,
        name,
        description,
        phone,
        email,
        address,
        sportType,
        adminUserId,
      });

      dispatch(
        addTournaments([
          {
            id: organizer.id,
            name: organizer.name,
            sportType: organizer.sportType,
          },
        ]),
      );

      if (logo) {
        await organizerResource.uploadLogo(organizer.id, logo);
        const updated = await organizerRepository.fetchOrganizer(organizer.id);
        if (updated) {
          organizer = updated;
        }
      }

      toast.success(i18n.t('settings.saveSettingsSuccess'));

      return organizer;
    } catch (err) {
      console.error(`${PREFIX}/upsertOrganizer error:`, err);
      toast.error(i18n.t('settings.saveSettingsInternalError'));

      throw err;
    }
  },
);

export const resetOrganizer = createAction(`${PREFIX}/resetOrganizer`);
